import React, { ReactNode } from 'react';
import {
  Container,
} from 'react-bootstrap';
import AppLoading from 'components/AppLoading';
import { useTranslation } from 'react-i18next';
import packageData from '../../../../package.json';

const { version } = packageData;
const hasTest = process.env.REACT_APP_CLIENT_KEY?.toString().indexOf( 'test_' ) !== -1 ? 'Env - QA' : '';

type MainLayoutProps = {
  readyLayout: boolean
  children: ReactNode;
};

function MainLayout( { readyLayout, children }: MainLayoutProps ) {
  const { t } = useTranslation();
  return (
    <Container className="body-container p-3">
      {readyLayout ? (
        children
      )
        : (
          <AppLoading />
        )}
      <div className="text--blue1 text--xs text-end mt-3">
        {`${t( 'version' )} ${version}; ${hasTest}`}
      </div>
    </Container>
  );
}

export default MainLayout;
